import { render } from "./EditAttribution.vue?vue&type=template&id=31a54f86"
import script from "./EditAttribution.vue?vue&type=script&lang=js"
export * from "./EditAttribution.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__